module.exports = __webpack_public_path__ + "static/pic_videoTeacher-d7cc18d7a6f2355af3aa577e526ca0cf.jpg";